import isNull from "lodash/isNull";
import type { Stripe } from "stripe";

export const getStripePriceValueWithPromo = (
  price: number,
  coupon: Stripe.Coupon
): number => {
  const { amount_off, percent_off } = coupon;

  let total = 0;
  if (!isNull(amount_off)) {
    total = price - amount_off / 100;
  } else if (!isNull(percent_off)) {
    total = price * ((100 - percent_off) / 100);
  }
  return total;
};
